export default "__VITE_ASSET__DPwpHKr0__"